module.exports = __webpack_public_path__ + "static/media/DSC03563.7991c9a6.JPG";